export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";